import React from 'react';
import styled from 'styled-components/macro';
import { useTranslate } from '../../../contexts/languageContext';
import { usePage } from '../../../contexts/pageContext';
import { useNomenclator } from '../../../contexts/nomenclatorContext';
import RankingStats from '../../../containers/RankingStats';
import EstadisticasConsolidado from '../../components/EstadisticasConsolidado';
import PrintStyles from '../../components/estilos';
import HeaderTitle from '../../../components/Headers/HeaderTitle/index'
import Footer from '../../../components/Footer/Footer';
import { getNomenclatorColorsByElecCode } from '../../../utils/nomenclatorUtils'
import Logo from '../../../assets/img/COBRANDING_ELECCIONES_2023-08.png';


function HeaderEstadisticasPrint({ nomenclator, elec, t }) {
  const nomenclatorColors = getNomenclatorColorsByElecCode(nomenclator, elec)

  return (
    <HeaderPrint>
      <HeaderTitle title={t('estadisticas')} subtitle={t(nomenclator.nomAmbitos[elec].n)} color={nomenclatorColors.c} marginBottom='unset' withDropdown={false} />
      <img src={Logo} alt={'Logos'} style={{ padding: '8px', height: "100%", width: "300px" }} />
    </HeaderPrint>
  )
}


export default function Estadisticas() {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const pageState = usePage();
  const { data, urlInfo } = pageState;
  const {
    elec,
    tipoDato,
    tipoDato2,
  } = urlInfo;


  return (
    <EstadisticasPrint>
      <PrintStyles />
      <div className="pdfPrint">
        <div>
          <HeaderEstadisticasPrint nomenclator={nomenclator} elec={elec} t={t} />
          <div className="main">
            <Table>
              <Title>{t('ranking') + ' ' + t(`tipoDato-${tipoDato}`)}</Title>
              <ContainerTabla>
                <RankingStats
                  tipo={tipoDato}
                  title={t(`tipoDato-${tipoDato}`)}
                  elec={elec}
                  data={data[0]}
                  nomenclator={nomenclator}
                />
              </ContainerTabla>
            </Table>
          </div>
        </div>
        <div>
          <HeaderEstadisticasPrint nomenclator={nomenclator} elec={elec} t={t} />
          <div className="main">
            <Table>
              <Title>{t('consolidado') + ' ' + t(`tipoDato-${tipoDato2}`)}</Title>
              <ContainerTabla>
                <EstadisticasConsolidado data={[{ tipo: tipoDato2, nombre: t(`tipoDato-${tipoDato2}`), data: [data[1]] }]} />
              </ContainerTabla>
            </Table>
          </div>
        </div>
        <Footer />
      </div>
    </EstadisticasPrint>
  );
}


const EstadisticasPrint = styled.div`
  color:#164192
`;

const ContainerTabla = styled.div`
  margin-top: 6px;
  background-color: white;
  overflow: auto;
`;

const HeaderPrint = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


const Title = styled.h3`
  font-weight: bold;
  text-transform: uppercase;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  width: 100%;
  border-bottom: 2px solid #164192;

`;
const Table = styled.div`
  @media print {
    break-after: page;
  }
`;

